/**
 * DEPRECATED_VOICE_RULES
 *
 * Mirror of the backend app/constants/deprecatedVoices.js.
 * Each entry is a { platform, langCode } pair. Any voice matching both fields
 * is considered deprecated. The frontend uses this to decide whether to fetch
 * the legacy voice list (GET /voices?include_deprecated=true) when editing
 * content that already references one of these voices.
 *
 * Keep this list in sync with the backend file when adding new deprecations.
 */
export const DEPRECATED_VOICE_RULES = [
    { platform: 'azure', langCode: 'en-US' },
    { platform: 'azure', langCode: 'en-IN' },
    { platform: 'azure', langCode: 'en-GB' },
    { platform: 'azure', langCode: 'en-AU' },
];

/**
 * Returns true if the given voice should be treated as deprecated.
 * @param {string} platform  - e.g. 'azure', 'polly', 'google'
 * @param {string} langCode  - e.g. 'en-US', 'en-IN'
 */
export const isDeprecatedVoice = (platform, langCode) =>
    DEPRECATED_VOICE_RULES.some(rule => rule.platform === platform && rule.langCode === langCode);

/**
 * Returns true if an audio_profile object (as stored on a slate block or integration) is deprecated.
 * Assumes lang_code is present on the audio_profile — this is the standard structure.
 * @param {{ platform?: string, lang_code?: string }} audioProfile
 */
export const isDeprecatedAudioProfile = (audioProfile) =>
    isDeprecatedVoice(audioProfile?.platform, audioProfile?.lang_code);
